import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { FirebaseService } from '../../services/firebase-service';
import { TextboxModule } from '../../../../../../libs/Shared/components/inputs/textbox/textbox.module';

@Component({
  selector: 'app-reset-password-page',
  imports: [FormsModule, CommonModule, TextboxModule],
  templateUrl: './reset-password-page.html',
  styles: ``,
})
export class ResetPasswordPage {

  password: string = '';
  password2: string = '';
  code: string | null = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly firebaseService: FirebaseService
  ) {
    this.route.queryParamMap.subscribe(params => {
      this.code = params.get('oobCode');
    });
  }

  async btnChangePassword_click() {
    if (this.password !== this.password2) {
      console.log("passwords don't match");
    } 
    else if (!this.code) {
      console.error("No code found");
    } 
    else {
      this.firebaseService.performResetPassword(this.code, this.password)
      .then((response: any) => {
        window.location.href = environment.suiteUrl + "/sign-in";
      })
      .catch((error: any) => {
        console.error("error: ", error);
      });
    }
  }
}
